import styled from 'styled-components';

export const PageContainer = styled.div`
  max-height: 100%;
  height: 100%;
  position: relative;
`;

export const MediaTypeContainer = styled.div`
  height: 6rem;
  width: 100%;
  display: flex;
  border-bottom: 1px solid #f3f4f6;
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.02);
`;

export const MediaTypeButton = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  gap: 0.8rem;
  justify-content: center;
  background-color: ${({ $selected }) => ($selected ? '#FFF' : '#BADAF7;')};
  color: ${({ $selected }) => ($selected ? '#040B10' : '#1672BA')};
  font-size: 1.8rem;
  font-weight: 500;
  letter-spacing: -0.17px;
  cursor: pointer;
`;

export const FilterContainer = styled.div`
  display: flex;
  padding: 1.2rem 2.4rem 1.2rem 1.2rem;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f3f4f6;
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.02);
`;

export const FilterRow = styled.div`
  display: flex;
  gap: 0.8rem;
`;

export const FilterButton = styled.div`
  border-radius: 10px;
  background: #badaf7;
  color: ${({ $selected }) => ($selected ? '#000' : '#3e9be4')};
  font-size: 1.5rem;
  font-weight: 400;
  letter-spacing: -0.15px;
  padding: 1rem 1.4rem;
  min-width: fit-content;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.6rem;
`;

export const FilterCount = styled.span`
  font-weight: 500;
  opacity: ${({ $selected }) => ($selected ? 0.55 : 0.7)};
`;

export const UploadMediaButton = styled.button`
  padding: 0 1.2rem;
  border-radius: 12px;
  border: 1px solid #61ade9;
  background: linear-gradient(93deg, #3e9be4 6.75%, #1672ba 93.25%);
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.42px;
  height: 3.9rem;
`;
